import { withTheme } from "@material-ui/core";
import React from "react";
import Button from '@material-ui/core/Button';

const ProgressBar = (props) => {
    const { bgcolor, completed } = props;
  
    const containerStyles = {
      height: 20,
      /*width: '20%',*/
      width: '200px',
      float: 'right',
      backgroundColor: "#e0e0de",
      borderRadius: 50,
      marginRight: 10,
      marginTop: 4,
      marginBottom: 4,
      backgroundColor: '#4d4f4d'
    }
  
    const fillerStyles = {
      height: '100%',
      width: `${completed}%`,
      backgroundColor: bgcolor,
      backgroundColor: 'var(--content-blue)',
      borderRadius: 'inherit',
      textAlign: 'right',
      transition: 'width 1s ease-in-out'
    }
    
    const progressStyles = {
      color: 'black',
      float: 'right',
      textAlign: 'right',
      fontWeight: 'bold',
      marginRight: 10,
      marginTop: 4,
      marginBottom: 4
    }

    const labelStyles = {
      padding: 5,
      color: 'white',
      fontWeight: 'bold'
    }

    const labelStylesEmpty = {
      padding: 6,
      color: 'white',
      fontWeight: 'bold'
    }
  
    return (
      <>
      {
        
        props.fixedClass == "progressBar-fixed" ?
        <div className="progressBar-fixed">     
          <div style={null}>
          <p style={{marginBottom: '5px'}}>Progress:</p>
          <hr style={{padding: '0'}}/>
          <span style={labelStyles}>{`${completed}%`}</span>
          </div>
        </div>
        :


        <div style={{float: 'right', width: '100%'}}>    
          <div style={containerStyles}>
            <div style={fillerStyles}>
              {completed == 0 ? <span style={labelStylesEmpty}>{`${completed}%`}</span> : <span style={labelStyles}>{`${completed}%`}</span> }
              
            </div>
          </div>
          <div style={progressStyles}><span>Progress:</span><br/></div>
          
        </div>

        
      }
      </>
    );
  };
  
  export default ProgressBar;